export default __webpack_public_path__ + "static/media/download-bg.36ee276f.svg";